import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import PropTypes from 'prop-types';
import React from 'react';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

export default function EnhancedTableHead(props) {
  const t = useLocalizedMessage();
  const { classes, order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const renderLabel = (headCell) => {
    const label = typeof headCell.label === 'string' && headCell.label.includes('.')
      ? t(headCell.label)
      : headCell.label;

    if (!headCell.visuallyHiddenLabel) return label;
    return <span className={classes.visuallyHidden}>{label}</span>;
  };

  return (
    <TableHead>
      <TableRow>
        {
          headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.action ? 'center' : (headCell.align || headCell.numeric ? 'right' : 'left')}
              className={`${headCell.compact ? classes.compactCell : ''} ${headCell.action ? classes.actionCell : ''}`.trim()}
              padding="normal"
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.sortable === false ? (
                renderLabel(headCell)
              ) : (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {renderLabel(headCell)}
                  {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                      {order === 'desc'
                        ? t('table.sort.descending')
                        : t('table.sort.ascending')}
                    </span>
                  ) : null}
                </TableSortLabel>
              )}
            </TableCell>
          ))
        }
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  headCells: PropTypes.arrayOf(PropTypes.object).isRequired,
};
